import { render, staticRenderFns } from "./Day06.vue?vue&type=template&id=2c13f9a8&"
import script from "./Day06.vue?vue&type=script&lang=js&"
export * from "./Day06.vue?vue&type=script&lang=js&"
import style0 from "./Day06.vue?vue&type=style&index=0&id=2c13f9a8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports